import { Button, Col, Row, Space } from "antd";
import { FC, useState } from "react";
import { renderErrorMessage } from "../../../../components/messages/errorMessage";
import ImportCaseStore from "../../../../contexts/importCaseStore";
import _t from "../../../../lang/translate";
import { downloadDocumentationUrl } from "../../../../services/merchantService";
import ImportMerchantInfo from "./importMerchantInfo";

interface ImportMerchantInfoEditableProps {
  startEditing: () => void;
  startChoosing: () => void;
}

const ImportMerchantInfoEditable: FC<ImportMerchantInfoEditableProps> = ({ startEditing, startChoosing }) => {
  const { importCase } = ImportCaseStore.useContainer();
  const { merchant } = importCase;

  const [loading, setLoading] = useState<boolean>(false);

  const handleDocumentDownload = async () => {
    try {
      setLoading(true);
      const { data } = await downloadDocumentationUrl(merchant?.id || 0);
      if (data.url) window.open(data.url, '_blank');
    } catch (error) {
      renderErrorMessage(error)
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ImportMerchantInfo />
      <Row justify="space-between" align="bottom">
        <Col />
        <Col>
          <Space size="large">
            {!!merchant && (
              <Button type="link" className="pl-0 pr-0 mt-1" onClick={handleDocumentDownload}
                disabled={loading}>
                {_t("download", "documentation")}
              </Button>
            )}
            <Button type="link" className="pl-0 pr-0 mt-1" onClick={startChoosing}>
              {_t("change")}
            </Button>
            <Button type="link" className="pl-0 pr-0 mt-1" disabled={!merchant?.id} onClick={startEditing}>
              {_t("edit")}
            </Button>
          </Space>
        </Col>
      </Row>
    </>
  );
};

export default ImportMerchantInfoEditable;
